import pako from 'pako';

/**
 * Generates a unique SAML request ID
 */
const generateSamlId = (): string => {
  return '_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
};

/**
 * Deflates (compresses) the SAML XML string
 */
const deflate = (str: string): Uint8Array => {
  const uint8Array = new TextEncoder().encode(str);
  return pako.deflateRaw(uint8Array);
};

/**
 * Converts Uint8Array to Base64 string
 */
const arrayBufferToBase64 = (buffer: Uint8Array): string => {
  let binary = '';
  const len = buffer.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(buffer[i]);
  }
  return btoa(binary);
};

/**
 * Generates the SAML URL for authentication request
 * @returns The generated SAML URL for login
 */
export const generateSAMLLoginURL = (): string | null => {
  try {
    const destination = process.env.REACT_APP_SAML_DESTINATION || '';
    const acsUrl = process.env.REACT_APP_SAML_ACS_URL || '';
    const spIssuer = process.env.REACT_APP_SAML_SP_ISSUER || 'NewsBanners';
    const baseUrl = process.env.REACT_APP_SAML_LOGIN_REDIRECT_URL || '';

    const issueInstant = new Date().toISOString();
    const requestId = generateSamlId();

    const requestSamlXml =
      `<?xml version="1.0" encoding="UTF-8"?>` +
      `<samlp:AuthnRequest ` +
      `xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol" ` +
      `ID="${requestId}" ` +
      `Version="2.0" ` +
      `IssueInstant="${issueInstant}" ` +
      `Destination="${destination}" ` +
      `ProtocolBinding="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST" ` +
      `AssertionConsumerServiceURL="${acsUrl}">` +
      `<saml:Issuer xmlns:saml="urn:oasis:names:tc:SAML:2.0:assertion">${spIssuer}</saml:Issuer>` +
      `<samlp:NameIDPolicy AllowCreate="true" ` +
      `Format="urn:oasis:names:tc:SAML:2.0:nameid-format:persistent"/>` +
      `</samlp:AuthnRequest>`;

    console.log('SAML Request XML:', requestSamlXml);

    // Deflate (compress) the XML
    const compressed = deflate(requestSamlXml);

    // Base64 encode
    const base64Encoded = arrayBufferToBase64(compressed);

    // URL encode
    const urlEncoded = encodeURIComponent(base64Encoded);

    // Construct final redirect URL
    const redirectUrl = baseUrl + urlEncoded;

    console.log('Generated SAML Login URL:', redirectUrl);

    return redirectUrl;
  } catch (error) {
    console.error('Error generating SAML Login URL:', error);
    return null;
  }
};
